var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{attrs:{"placeholder":_vm.$t('lang.Please select an organization'),"options":_vm.$store.state.queryUnitTreeList,"props":{ checkStrictly: true ,label:'name',children:'subUnit',value:'unitNo'},"clearable":""},on:{"change":_vm.handel}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c5eba60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/queryUnitTree.vue
// module id = null
// module chunks = 